import config from '__api/config';
import { getMonthRwdList } from '__api/dsbc/inv/getMonthRwdList';
import { invUserRank, RankInvDataVO } from '__api/dsbc/inv/invUserRank';
import { finishTask } from '__api/zqhd/FinishTask';
import { ShareButton } from '__components/ShareButton';
import { shareAdConfig } from '__constants/AdConfig';
import { AppShare } from '__utils/appShare';
import { RootSiblingContainer } from 'emrn-design';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { Toast } from 'emrn-design/Toast';
import { rpx } from 'emrn-design/rpx';
import { trackEvent } from 'emrn-hybrid/trackEvent';
import { EmPageProps } from 'emrn-navigation';
import { AnimatedHeader } from 'emrn-navigation/AnimatedHeader';
import React, { Component } from 'react';
import {
  StyleSheet,
  Text,
  View,
  Image,
  NativeSyntheticEvent,
  NativeScrollEvent,
  Animated,
  ImageBackground,
  Dimensions,
  FlatList,
} from 'react-native';
import { MonthRewardPop } from '../dialogPops/monthAwardPop';
import { ShareTipPop } from '../dialogPops/shareTipPop';

/**
 * 状态
 */
interface InviteRankingState {
  /**
   * y轴滑动位移
   */
  scrollY: Animated.Value;
  /**
   * 榜单状态 1-本月榜单 2-上月榜单 3-总榜单
   */
  rankType: number;
  /**
   * 底部高度
   */
  bottomHeight: number;
  /**
   * 榜单数据
   */
  invRankData: RankInvDataVO[] | undefined;
  /**
   * 榜单下方个人邀请数据
   */
  selfInfo: RankInvDataVO;
  /**
   * 是否展示上月榜
   */
  isShowLastMonth: boolean;
}

export class InviteRanking extends Component<EmPageProps, InviteRankingState> {
  static displayName = 'InviteRanking';
  private toast = React.createRef<Toast>();
  private shareTipPop = React.createRef<ShareTipPop>();
  //配置活动时间列表
  private isEndOfActivity: boolean = true;
  private monthRewardPop = React.createRef<MonthRewardPop>();

  constructor(props: EmPageProps) {
    super(props);
    this.state = {
      scrollY: new Animated.Value(0),
      rankType: 1,
      bottomHeight: 0,
      invRankData: undefined,
      selfInfo: {},
      isShowLastMonth: false,
    };
  }
  async componentDidMount() {
    await this.initData(4);
  }
  async initData(type: number) {
    if (type === 1) {
      await this._invRank('1');
    } else if (type === 2) {
      await this._invRank('2');
    } else if (type === 3) {
      await this._invRank('0');
    } else {
      await this._invRank('2');
      await this._invRank('1');
    }
    //月榜奖励
    if (!this.isEndOfActivity) {
      await this._getMonthRwdList();
    }
  }
  /**
   * 获取月榜奖励
   */
  _getMonthRwdList = async () => {
    try {
      //id: 赛项ID
      let res = await getMonthRwdList({ invId: config.invId });
      if (res && res.IsSuccess) {
        if (res.Data && res.Data.length > 0) {
          res.Data.forEach(item => {
            if (item.getNote && +item.getNote === 1) {
              this.monthRewardPop.current?.show(item.rewardValue || '', item.rewardIndex || '');
              return;
            }
          });
        }
      }
    } catch (error) {
      return;
    }
  };
  onScroll = (event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const { y } = event.nativeEvent.contentOffset;
    Animated.event([{ y: this.state.scrollY }])({ y });
  };
  rankToReward = (rank: number) => {
    const nameArr = ['500元京东卡', '300元京东卡', '200元京东卡', '100元京东卡', '50元京东卡'];
    let name = '-';
    if (rank === 1) {
      name = nameArr[0];
    } else if (rank === 2) {
      name = nameArr[1];
    } else if (rank === 3) {
      name = nameArr[2];
    } else if (rank === 4 || rank === 5) {
      name = nameArr[3];
    } else if ([6, 7, 8, 9, 10].includes(rank)) {
      name = nameArr[4];
    }
    return name;
  };
  //增加抽奖次数
  _finishTask = async (taskId: string) => {
    try {
      await finishTask({
        taskId,
      });
    } catch (e) {
      console.log(e);
    }
  };
  /**
   * 榜单
   * 0-总榜 1月榜 2上月榜
   */
  _invRank = async (type: string) => {
    try {
      //id: 赛项ID
      let res = await invUserRank({ invId: config.invId, rankNum: type });
      console.log('res', res);
      if (res && res.IsSuccess) {
        if (+type === 1) {
          this.setState({
            invRankData: res.Data?.data || [],
            selfInfo: res.Data?.selfInfo || {},
          });
        } else if (+type === 2) {
          if (res.Data?.data && res.Data?.data.length > 0) {
            this.setState({
              invRankData: res.Data?.data || [],
              selfInfo: {},
              isShowLastMonth: true,
            });
          }
        } else {
          this.setState({
            invRankData: res.Data?.data || [],
            selfInfo: {},
          });
        }
      }
    } catch (error) {
      return;
    }
  };
  renderSec3 = () => {
    const styles = createStyles();
    const { rankType, invRankData, selfInfo, isShowLastMonth } = this.state;

    if (!invRankData) {
      return null;
    }
    let length = invRankData.length;
    if (length > 0 && length < 10) {
      for (let i = 0; i < 10 - length; i++) {
        invRankData.push({
          cnt: '-',
          nick: '虚位以待',
          rank: (i + 1 + length).toString(),
          reward: this.rankToReward(i + 1 + length),
          uid: '',
        });
      }
    }
    return (
      <View style={styles.sec3_main}>
        <LinearGradient
          colors={['#DBFFFF', '#ffffff']}
          start={{ x: 0, y: 0 }}
          end={{ x: 0, y: 0.1 }}
          style={styles.content}
        >
          <View style={styles.sec3_tit_main}>
            <EmTouchableOpacity
              style={styles.no1NoAcBtn}
              activeOpacity={1}
              onPress={async () => {
                trackEvent('csj.gxyxhdy.yqphb.bybd');
                if (rankType === 1) {
                  return;
                }
                await this._invRank('1');
                this.setState({
                  rankType: 1,
                });
              }}
            />
            {isShowLastMonth ? (
              <EmTouchableOpacity
                activeOpacity={1}
                style={styles.no2NoAcBtn}
                onPress={async () => {
                  if (rankType === 2) {
                    return;
                  }
                  trackEvent('csj.gxyxhdy.yqphb.sybd');
                  await this._invRank('2');
                  this.setState({
                    rankType: 2,
                  });
                }}
              />
            ) : null}
            <EmTouchableOpacity
              activeOpacity={1}
              style={styles.no3NoAcBtn}
              onPress={async () => {
                if (rankType === 3) {
                  return;
                }
                trackEvent('csj.gxyxhdy.yqphb.zbd');
                await this._invRank('0');
                this.setState({
                  rankType: 3,
                });
              }}
            />
          </View>
          <ImageBackground
            style={styles.topBgActive}
            source={require('../../images/invite/topBgActive.png')}
            resizeMode={'stretch'}
          />
          {rankType === 1 ? (
            <View style={styles.sec3_tit_main_c}>
              <Image
                style={styles.no1Active}
                source={require('../../images/invite/no1Active.png')}
                resizeMode={'stretch'}
              />
              {isShowLastMonth ? (
                <Image
                  style={styles.no2NoActive}
                  source={require('../../images/invite/no2NoActive.png')}
                  resizeMode={'stretch'}
                />
              ) : null}
              <Image
                style={styles.no3NoActive}
                source={require('../../images/invite/no3NoActive.png')}
                resizeMode={'stretch'}
              />
            </View>
          ) : rankType === 2 ? (
            <View style={styles.sec3_tit_main_c}>
              <Image
                style={styles.no1NoActive}
                source={require('../../images/invite/no1NoActive.png')}
                resizeMode={'stretch'}
              />
              {isShowLastMonth ? (
                <Image
                  style={styles.no2Active}
                  source={require('../../images/invite/no2Active.png')}
                  resizeMode={'stretch'}
                />
              ) : null}

              <Image
                style={styles.no3NoActive}
                source={require('../../images/invite/no3NoActive.png')}
                resizeMode={'stretch'}
              />
            </View>
          ) : (
            <View style={styles.sec3_tit_main_c}>
              <Image
                style={styles.no1NoActive}
                source={require('../../images/invite/no1NoActive.png')}
                resizeMode={'stretch'}
              />
              {isShowLastMonth ? (
                <Image
                  style={styles.no2NoActive}
                  source={require('../../images/invite/no2NoActive.png')}
                  resizeMode={'stretch'}
                />
              ) : null}

              <Image
                style={styles.no3Active}
                source={require('../../images/invite/no3Active.png')}
                resizeMode={'stretch'}
              />
            </View>
          )}
          {invRankData && invRankData.length > 0 ? (
            <View style={styles.top_three}>
              <ImageBackground
                style={styles.rangk_two}
                source={require('../../images/invite/no2Bg.png')}
                resizeMode={'stretch'}
              >
                <Spacer size={rpx(12)} />
                <ImageBackground
                  style={styles.image_back}
                  source={require('../../images/invite/no2.png')}
                  resizeMode={'stretch'}
                >
                  <Image
                    style={styles.no2_img}
                    source={{ uri: `https://avator.eastmoney.com//qface/${invRankData[1].uid}/180` }}
                    resizeMode={'stretch'}
                  />
                </ImageBackground>
                <Spacer size={rpx(8)} />
                <Text style={styles.text_no2_nick} numberOfLines={1}>
                  {invRankData[1].nick}
                </Text>
                <Spacer size={rpx(8)} />
                <Text style={styles.text_no1}>
                  2<Text style={styles.text_no_sub}>nd</Text>
                </Text>
                <Spacer size={rpx(4)} />
                <Text style={styles.text_no3} numberOfLines={1}>
                  成功邀请<Text style={styles.text_no_red}>{invRankData[1].cnt}</Text>人
                </Text>
                <Spacer size={rpx(2)} />
                {rankType !== 3 ? (
                  <>
                    <Text style={styles.text_no3}>
                      奖励<Text style={styles.text_no_red}>300元</Text>京东卡
                    </Text>
                  </>
                ) : (
                  <Spacer size={rpx(20)} />
                )}
              </ImageBackground>
              <ImageBackground
                style={styles.rangk_one}
                source={require('../../images/invite/no1Bg.png')}
                resizeMode={'stretch'}
              >
                <Spacer size={rpx(19)} />
                <ImageBackground
                  style={styles.image_back1}
                  source={require('../../images/invite/no1.png')}
                  resizeMode={'stretch'}
                >
                  <Image
                    style={styles.no1_img}
                    source={{ uri: `https://avator.eastmoney.com//qface/${invRankData[0].uid}/180` }}
                    resizeMode={'stretch'}
                  />
                </ImageBackground>
                <Spacer size={rpx(8)} />
                <Text style={styles.text_no2_nick} numberOfLines={1}>
                  {invRankData[0].nick}
                </Text>
                <Spacer size={rpx(8)} />
                <Text style={[styles.text_no1]}>
                  1<Text style={styles.text_no_sub}>st</Text>
                </Text>
                <Spacer size={rpx(4)} />
                <Text style={styles.text_no3} numberOfLines={1}>
                  成功邀请<Text style={styles.text_no_red}>{invRankData[0].cnt}</Text>人
                </Text>
                <Spacer size={rpx(2)} />
                {rankType !== 3 ? (
                  <>
                    <Text style={styles.text_no3}>
                      奖励<Text style={styles.text_no_red}>500元</Text>京东卡
                    </Text>
                  </>
                ) : (
                  <Spacer size={rpx(21)} />
                )}
              </ImageBackground>
              <ImageBackground
                style={styles.rangk_two}
                source={require('../../images/invite/no3Bg.png')}
                resizeMode={'stretch'}
              >
                <Spacer size={rpx(12)} />
                <ImageBackground
                  style={styles.image_back}
                  source={require('../../images/invite/no3.png')}
                  resizeMode={'stretch'}
                >
                  <Image
                    style={styles.no1_img}
                    source={{ uri: `https://avator.eastmoney.com/qface/${invRankData[2].uid}/180` }}
                    resizeMode={'stretch'}
                  />
                </ImageBackground>
                <Spacer size={rpx(8)} />
                <Text style={styles.text_no2_nick} numberOfLines={1}>
                  {invRankData[2].nick}
                </Text>
                <Spacer size={rpx(8)} />
                <Text style={[styles.text_no1]}>
                  3<Text style={styles.text_no_sub}>rd</Text>
                </Text>
                <Spacer size={rpx(4)} />
                <Text style={styles.text_no3} numberOfLines={1}>
                  成功邀请<Text style={styles.text_no_red}>{invRankData[2].cnt}</Text>人
                </Text>
                <Spacer size={rpx(2)} />
                {rankType !== 3 ? (
                  <>
                    <Text style={styles.text_no3}>
                      奖励<Text style={styles.text_no_red}>200元</Text>京东卡
                    </Text>
                  </>
                ) : (
                  <Spacer size={rpx(20)} />
                )}
              </ImageBackground>
            </View>
          ) : (
            <View style={styles.nodata_c}>
              <Image
                style={styles.nodata_img}
                source={require('../../images/invite/nodata.png')}
                resizeMode={'stretch'}
              />
              <Spacer size={20} />
              <Text style={styles.nodata_text}>虚位以待，等你来占！</Text>
            </View>
          )}
          <Spacer size={rpx(30)} />
          <View style={styles.bottom_content}>
            <Spacer size={rpx(20)} />
            {+rankType !== 3 ? (
              <View style={styles.sec3_rankTitle}>
                <Text style={styles.sec3_rank1}>排名</Text>
                <Text style={styles.sec3_rank2}>用户名</Text>
                <Text style={styles.sec3_rank2}>邀请成功数</Text>
                <Text style={styles.sec3_rank3}>奖品</Text>
              </View>
            ) : (
              <View style={styles.sec3_rankTitle}>
                <Text style={styles.sec3_rank1}>排名</Text>
                <Text style={styles.sec3_rank2}>用户名</Text>
                <Text style={styles.sec3_rank2}>邀请成功数</Text>
              </View>
            )}
            {invRankData && invRankData.length > 0 ? (
              <View style={{ height: rankType !== 3 ? rpx(350) : rpx(350), overflow: 'scroll' }}>
                <FlatList
                  data={invRankData.slice(3, 10)}
                  nestedScrollEnabled
                  ItemSeparatorComponent={() => {
                    return <View style={{ height: rpx(1), backgroundColor: '#999999', opacity: 0.2 }} />;
                  }}
                  renderItem={({ item, index }) => {
                    return (
                      <View style={[styles.sec3_item]} key={index}>
                        <Text style={styles.sec3_rank_text1} numberOfLines={1}>
                          {item.rank}
                        </Text>
                        <Text style={styles.sec3_rank_text2} numberOfLines={1}>
                          {item.nick}
                        </Text>
                        <Text
                          style={[styles.sec3_rank_text3, Number(item.cnt) > 0 ? styles.sec3_rank_text3_1 : null]}
                          numberOfLines={2}
                        >
                          {item.cnt}
                        </Text>
                        {+rankType === 3 ? null : (
                          <View
                            style={{ width: rpx(100), display: 'flex', flexDirection: 'row', justifyContent: 'center' }}
                          >
                            <Image
                              style={styles.sec3_rank_img}
                              source={require('../../images/invite/rnkJd.png')}
                              resizeMode={'stretch'}
                            />
                            <Text style={styles.sec3_rank_text4} numberOfLines={2}>
                              {item.reward}
                            </Text>
                          </View>
                        )}
                      </View>
                    );
                  }}
                  initialScrollIndex={0}
                />
                {selfInfo && +rankType === 1 ? (
                  <LinearGradient style={styles.sec3_b_c} colors={['#FFF2B9', '#FFFFFF']}>
                    <View style={styles.sec3_b_c}>
                      <ImageBackground style={styles.sec3_rank_bg} source={require('../../images/invite/starBg.png')}>
                        <Text
                          style={[
                            styles.sec3_rank_textSelf_rank,
                            {
                              fontSize: selfInfo.rank?.length && selfInfo.rank?.length >= 3 ? rpx(10) : rpx(18),
                            },
                          ]}
                          numberOfLines={2}
                        >
                          {selfInfo.rank}
                        </Text>
                      </ImageBackground>
                      <Text style={styles.sec3_rank_text2_nick} numberOfLines={1}>
                        {selfInfo.nick}
                      </Text>
                      <Text
                        style={[
                          styles.sec3_rank_textSelf_Count,
                          { fontSize: selfInfo && selfInfo.cnt && +selfInfo.cnt > 100 ? rpx(12) : rpx(14) },
                        ]}
                        numberOfLines={1}
                      >
                        {selfInfo.cnt}
                      </Text>
                      <View
                        style={{ width: rpx(120), display: 'flex', flexDirection: 'row', justifyContent: 'center' }}
                      >
                        {selfInfo && selfInfo.rank && +selfInfo.rank <= 10 ? (
                          <Image
                            style={styles.sec3_rank_img}
                            source={require('../../images/invite/rnkJd.png')}
                            resizeMode={'stretch'}
                          />
                        ) : null}
                        <Text style={styles.sec3_rank_textSelf} numberOfLines={2}>
                          {selfInfo.reward ? selfInfo.reward : '无'}
                        </Text>
                      </View>
                    </View>
                  </LinearGradient>
                ) : null}
              </View>
            ) : (
              <View style={styles.nodata_c}>
                <Image
                  style={styles.nodata_img}
                  source={require('../../images/invite/nodata.png')}
                  resizeMode={'stretch'}
                />
                <Spacer size={20} />
                <Text style={styles.nodata_text}>虚位以待，等你来占！</Text>
              </View>
            )}
          </View>
        </LinearGradient>
      </View>
    );
  };
  render() {
    const styles = createStyles();
    const { scrollY } = this.state;
    return (
      <RootSiblingContainer>
        <Animated.ScrollView style={styles.container} bounces={false} scrollEventThrottle={10} onScroll={this.onScroll}>
          <View style={styles.sec_3}>
            <Image style={styles.headerBc} source={require('../../images/invite/topbg.png')} resizeMode={'stretch'} />
            {this.renderSec3()}
          </View>
        </Animated.ScrollView>
        <AnimatedHeader
          title={'邀请排行榜'}
          scrollY={scrollY}
          titleColor="#333333"
          backTheme={'black'}
          normalBackgroundColor="#7de1f0"
          transparentBackgroundColor="rgba(227,103,38,0)"
          titleRight={() => {
            return (
              <ShareButton
                onPress={async () => {
                  const res = await AppShare({
                    trackCode: 'csj.gxyxhdy.ysj.fxqd',
                    groupCode: shareAdConfig.common.code,
                  });
                  if (res) {
                    this._finishTask('cw_05');
                  }
                  setTimeout(() => {
                    res && this.shareTipPop.current?.show();
                  }, 200);
                }}
              />
            );
          }}
        />
        <ShareTipPop
          ref={this.shareTipPop}
          onPress={() => {
            const { push } = this.props.navigation;
            push('Invite', { toScroll: true });
          }}
        />
        <Toast ref={this.toast} />
      </RootSiblingContainer>
    );
  }
}
function createStyles() {
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: 'rgba(149, 235, 250,1)',
    },
    shareBtn: {
      height: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    shareText: {
      color: '#fff',
      fontSize: rpx(14),
      lineHeight: rpx(14),
    },
    headerBc: {
      height: rpx(165),
      width: '100%',
    },
    sec3_item: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: rpx(6),
      width: rpx(320),
      height: rpx(54),
    },
    sec3_rank2: {
      color: '#999999',
      fontSize: rpx(12),
      flex: 3,
      textAlign: 'center',
      fontWeight: 'bold',
    },
    sec3_rank3: {
      color: '#999999',
      fontSize: rpx(12),
      flex: 3,
      textAlign: 'center',
      fontWeight: 'bold',
      marginRight: rpx(5),
    },
    sec3_rank1: {
      color: '#999999',
      fontSize: rpx(12),
      flex: 1.5,
      textAlign: 'center',
      fontWeight: 'bold',
    },
    sec3_rankTitle: {
      flexDirection: 'row',
      width: rpx(320),
      paddingBottom: rpx(10),
    },
    sec3_text2: {
      fontSize: rpx(15),
      color: '#333333',
      opacity: 0.5,
      lineHeight: rpx(18),
    },
    sec3_text1: {
      height: rpx(16),
      fontSize: rpx(15),
      color: '#333333',
      lineHeight: rpx(18),
    },
    lineBar: {
      marginTop: rpx(5),
      width: rpx(18),
      height: rpx(5),
    },
    sec3_tit_main: {
      width: rpx(345),
      position: 'relative',
      flexDirection: 'row',
      justifyContent: 'space-between',
      zIndex: 99,
    },
    sec3_tit_main_c: {
      marginTop: rpx(-58),
      position: 'relative',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
    },
    lastMonth: {
      marginLeft: rpx(80),
      position: 'relative',
    },
    no1NoActive: {
      position: 'relative',
      left: rpx(0),
      top: rpx(0),
      width: rpx(142),
      height: rpx(53.5),
      zIndex: 3,
    },
    no2Active: {
      position: 'absolute',
      left: rpx(80),
      top: rpx(0),
      width: rpx(186),
      height: rpx(53.5),
      zIndex: 9,
    },
    no3Active: {
      position: 'absolute',
      width: rpx(142.5),
      height: rpx(53.5),
      right: rpx(0),
      top: rpx(0),
      zIndex: 9,
    },
    sec3Bg_img: {
      width: '100%',
      height: rpx(770),
      alignItems: 'center',
      justifyContent: 'center',
    },
    sec3_main: {
      marginTop: rpx(-80),
      width: rpx(375),
      paddingHorizontal: rpx(10),
      alignItems: 'center',
      flex: 1,
    },
    content: {
      height: rpx(680),
      width: rpx(345),
      borderRadius: rpx(24),
    },
    sec3_b_c: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      width: rpx(320),
      height: rpx(55),
      borderRadius: rpx(12),
      paddingLeft: rpx(5),
    },
    sec3_rank_bg: {
      width: rpx(41),
      height: rpx(41),
      alignItems: 'center',
      justifyContent: 'center',
    },
    sec3_rank_textSelf_rank: {
      color: '#9A4108',
      fontSize: rpx(14),
      fontWeight: 'bold',
      flex: 1.5,
      textAlign: 'center',
      lineHeight: rpx(41),
    },
    sec3_rank_text4: {
      color: '#333333',
      fontSize: rpx(12),
      fontWeight: 'bold',
      flex: 3,
      textAlign: 'center',
    },
    sec3_rank_textSelf: {
      color: '#333333',
      fontSize: rpx(12),
      fontWeight: 'bold',
      flex: 3,
      textAlign: 'right',
      marginRight: rpx(15),
    },
    sec3_rank_textSelf_Count: {
      color: '#333333',
      fontSize: rpx(14),
      fontWeight: 'bold',
      flex: 3,
      textAlign: 'center',
    },
    sec3_rank_img: {
      width: rpx(26),
      height: rpx(19),
    },
    sec3_rank_text3: {
      color: '#333333',
      fontSize: rpx(14),
      fontWeight: 'bold',
      flex: 3,
      textAlign: 'center',
    },
    sec3_rank_text3_1: {
      color: '#333333',
    },
    sec3_rank_text2: {
      color: '#333333',
      fontSize: rpx(12),
      flex: 3,
      textAlign: 'center',
    },
    sec3_rank_text2_nick: {
      color: '#333333',
      fontSize: rpx(12),
      width: rpx(100),
      marginLeft: rpx(4),
      textAlign: 'left',
    },
    sec3_rank_text1: {
      color: '#999999',
      fontSize: rpx(14),
      fontWeight: 'bold',
      flex: 1.5,
      textAlign: 'center',
    },
    first_img: {
      width: rpx(26),
      height: rpx(21),
    },
    nodata_c: {
      marginTop: rpx(100),
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: rpx(20),
    },
    nodata_text: {
      fontSize: rpx(15),
      color: '#999999',
    },
    nodata_img: {
      width: rpx(120),
      height: rpx(120),
    },
    sec3_tit: {
      fontSize: rpx(18),
      color: '#5F2818',
      marginLeft: rpx(5),
    },
    sec_header: {
      flexDirection: 'row',
      paddingLeft: rpx(11),
      paddingTop: rpx(10),
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    right_tip_text: {
      color: 'rgba(95, 40, 24, 0.6)',
      fontSize: rpx(12),
      marginLeft: rpx(5),
      marginTop: rpx(2),
      marginRight: rpx(15),
    },
    left_title: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    topBgActive: {
      width: rpx(344.5),
      height: rpx(30),
      position: 'absolute',
      top: rpx(45),
      zIndex: 999,
    },
    top_three: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      height: rpx(260),
      justifyContent: 'space-evenly',
      width: rpx(320),
      marginTop: rpx(-65),
      marginLeft: rpx(13),
      zIndex: 9,
    },
    rangk_two: {
      height: rpx(162),
      width: rpx(104),
      alignItems: 'center',
    },
    rangk_one: {
      marginTop: rpx(-40),
      height: rpx(162),
      width: rpx(104),
      alignItems: 'center',
    },
    image_back: {
      marginTop: rpx(-10),
      width: rpx(56),
      height: rpx(59),
      position: 'relative',
    },
    text_no2_nick: {
      fontSize: rpx(10),
      color: '#333333',
      fontWeight: 'bold',
      marginTop: rpx(5),
    },
    text_no2: {
      fontSize: rpx(10),
      color: '#758BA9',
      fontWeight: 'bold',
    },
    text_no1: {
      fontSize: rpx(30),
      color: '#333333',
      fontWeight: 'bold',
      fontStyle: 'italic',
    },
    text_no_sub: {
      marginLeft: rpx(2),
      fontStyle: 'normal',
      fontSize: rpx(12),
    },
    text_no1_bottom: {
      fontSize: rpx(11),
      color: '#BD8619',
      fontWeight: 'bold',
    },
    no2_img: {
      position: 'absolute',
      top: rpx(7),
      left: rpx(4),
      width: rpx(50),
      height: rpx(50),
      borderRadius: rpx(45),
    },
    image_back1: {
      width: rpx(56),
      height: rpx(59),
      marginTop: rpx(-35),
      position: 'relative',
    },
    no1_img: {
      position: 'absolute',
      top: rpx(7),
      left: rpx(3.5),
      width: rpx(50),
      height: rpx(50),
      borderRadius: rpx(61),
    },
    no1Active: {
      position: 'relative',
      zIndex: 9,
      top: rpx(0),
      left: rpx(0),
      width: rpx(142),
      height: rpx(53.5),
    },
    no2NoActive: {
      position: 'absolute',
      zIndex: 1,
      left: rpx(82),
      width: rpx(179),
      height: rpx(53.5),
    },
    no2NoAcBtn: {
      position: 'relative',
      top: rpx(0),
      width: rpx(120),
      height: rpx(57),
      zIndex: 99,
    },
    no1NoAcBtn: {
      position: 'relative',
      top: rpx(0),
      left: rpx(0),
      width: rpx(120),
      height: rpx(57),
      zIndex: 20,
    },
    no3NoActive: {
      position: 'relative',
      right: rpx(0),
      width: rpx(142),
      height: rpx(53.5),
      zIndex: 1,
    },
    no3NoAcBtn: {
      position: 'relative',
      top: rpx(0),
      right: rpx(0),
      width: rpx(120),
      height: rpx(57),
      zIndex: 19,
    },
    text_no3: {
      fontSize: rpx(11),
      color: '#333333',
      fontWeight: 'bold',
    },
    text_no_red: {
      color: '#FF3F01',
    },
    line_ranking: {
      width: rpx(209),
      height: rpx(3),
    },
    bottom_content: {
      alignItems: 'center',
    },
    sec_3: {
      flex: 1,
      alignItems: 'center',
    },
  });
}
